// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"511":"cart","793":"pizzaInfo","809":"notFount"}[chunkId] + "." + {"511":"0f5fdb83","793":"bacfa2e2","809":"c240aad2"}[chunkId] + ".chunk.js";
};